import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material';
import {TimeTrackerService} from '../time-tracker-service.service';
import {AngularFireDatabase} from 'angularfire2/database';
import {ScheduleService} from '../services/ScheduleService';
import {AngularFireAuth} from 'angularfire2/auth';
import {Reason} from '../../models/Reason';
import {TemplateModalComponent} from '../modals/template-modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {BsModalService} from 'ngx-bootstrap';
import {Subscription} from 'rxjs/Subscription';
import {User} from '../../models/User';
import {Observable} from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import {Company} from '../../models/company';
import * as moment from 'moment';
import {Configuration} from '../../models/Configuration';
import {ReasonModalComponent} from '../modals/template-reason-modal';
import {isArray} from 'util';
import {Wifi} from '../../models/Wifi';
import {AllowedDevice} from '../../models/AllowedDevice';
import {AllowedDeviceModalComponent} from '../modals/template-allowed-device-modal';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

    reasons: Array<Reason> = [];
    allowedDevices: Array<AllowedDevice> = [];

    bsModalRef: BsModalRef;

    userInfo: User = new User();
    userSubscription: Subscription;
    user: Observable<firebase.User>;
    company: Company = new Company();
    configuration: Configuration;

    companyId: string;
    subCompanyGroups: Array<Company> = [];
    constructor(public afAuth: AngularFireAuth, public af: AngularFireDatabase, public trans: TranslateService,
                public tts: TimeTrackerService, public snackBar: MatSnackBar, public bsModalService: BsModalService,
                public translateService: TranslateService, public scheduleService: ScheduleService) {
        this.user = this.afAuth.authState;
    }

    newWifiModel(): Wifi {
        return new Wifi();
    }

    ngOnInit() {
        this.configuration = new Configuration();
        this.userSubscription = this.user.subscribe(userInfo => {
            this.userSubscription.unsubscribe();
            if (userInfo) {
                this.tts.getUserFromId(userInfo.uid, userProfile => {
                    if (userProfile.payload.val()) {
                        this.userInfo = userProfile.payload.val();
                        this.companyId = this.userInfo.companyId;
                        this.loadCompany(this.companyId);
                        this.loadChildCompanies();
                    } else {
                        this.translateService.get('DASHBOARD.CANT_LOAD_INFO').subscribe(str => {
                            this.snackBar.open(str, null, {duration: 2000});
                        });
                    }
                });
            }
        });
    }

    public loadChildCompanies() {
        this.subCompanyGroups = [];
        //Force here load child companies from owner userId
        this.tts.getCompanyFromId(this.userInfo.companyId, rootCompany => {
            this.subCompanyGroups.push(rootCompany);
            this.tts.getChildGroups(rootCompany.id, data => {
                this.subCompanyGroups = this.subCompanyGroups.concat(data);
            });
        });
    }

    // public loadDataFromCompany(){
    //     console.log('Selected Company: ' + this.companyId);
    //     this.tts.getTeamsFromCompany(this.companyId, teams => {
    //         this.listTeams = teams;
    //     });
    // }
    loadCompany(companyId: string) {
        this.tts.getCompanyFromId(companyId, company => {
            this.company = company;
        });
        this.loadReasons(companyId);
        this.loadConfig(companyId);
        this.loadAllowedDevices(companyId);
    }

    loadReasons(companyId: string) {
        this.tts.getReasonsFromCompanyId(companyId, reasons => {
            console.log('getReasonsFromCompanyId: ', reasons);
            if (isArray(this.reasons)) {
                this.reasons = reasons.reverse();
            } else {
                this.reasons = [];
            }
        });
    }

    loadConfig(companyId: string) {
        this.tts.getConfigurationFromCompanyId(companyId, configuration => {

            console.log('Load config, ', configuration);
            if (!configuration) {
                this.configuration = new Configuration();
            } else {
                this.configuration = configuration;
                if (!isArray(this.configuration.wifiList)) {
                    this.configuration.wifiList = [];
                }
            }
        });
    }

    updateConfiguration(companyId: string, configuration: Configuration) {
        this.af.object(TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.CONFIG)
            .set(configuration);
    }

    updateCompany(company: Company) {
        if (!company) {
            return;
        }
        this.bsModalRef = this.bsModalService.show(TemplateModalComponent);
        const mod = Company.toModelTemplate(company);
        mod.mode_edit = true;
        mod.config.title = 'MODEL.COMPANY.EDIT_COMPANY';
        this.bsModalRef.content.model = mod;
    }

    updateWifi(wifi: Wifi) {
        if (!wifi) {
            return;
        }
        if (wifi.name && wifi.bssid && wifi.latitude && wifi.longitude) {
            this.af.object(TimeTrackerService.COMPANY_DATA + '/'
                + this.companyId + '/'
                + TimeTrackerService.CONFIG + '/' + TimeTrackerService.WIFI)
                .set(this.configuration.wifiList);
        }
    }

    loadAllowedDevices(companyId: string) {
        this.tts.getAllowedDevices(companyId, devices => {
            console.log('getAllowedDevices: ', devices);
            if (isArray(this.allowedDevices)) {
                this.allowedDevices = devices.reverse();
            } else {
                this.allowedDevices = [];
            }
        });
    }

    /**
     * @param {AllowedDevice} allowedDevice @Nullable
     */
    addOrEditAllowedDevice(allowedDevice: AllowedDevice) {
        this.bsModalRef = this.bsModalService.show(AllowedDeviceModalComponent);
        const mod = AllowedDevice.toModelTemplate(allowedDevice, this.companyId);

        if (allowedDevice == null) {
            mod.config.title = 'MODEL.ALLOWED_DEVICE.ADD_DEVICE';
            mod.mode_create = true;
        } else {
            mod.config.title = 'MODEL.ALLOWED_DEVICE.EDIT_DEVICE';
            mod.mode_edit = true;
            mod.mode_delete = true;
        }
        this.bsModalRef.content.model = mod;
    }


    /**
     * @param {Reason} reason @Nullable
     */
    addOrEditReason(reason: Reason) {
        this.bsModalRef = this.bsModalService.show(ReasonModalComponent);
        const mod = Reason.toModelTemplate(reason, this.companyId);

        if (reason == null) {
            mod.config.title = 'MODEL.REASON.CREATE_REASON';
            mod.mode_create = true;
        } else {
            mod.config.title = 'MODEL.REASON.EDIT_REASON';
            mod.mode_edit = true;
            mod.mode_delete = true;
        }
        this.bsModalRef.content.model = mod;
    }

    toMoment(strDate) {
        if (!strDate) {
            return '';
        }
        return moment(strDate).format('ll');
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/settings.component.ts